import React from 'react';
import styled from 'styled-components';
import ConsultCard from './ConsultCard';
import { FileText } from 'lucide-react';

const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 3rem;
  color: #6b7280;
  background: #f9fafb;
  border-radius: 12px;
  border: 1px dashed #d1d5db;
`;

const Disclaimer = styled.div`
  background: #fef3c7;
  border: 1px solid #fbbf24;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1.5rem;
  color: #92400e;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

function ConsultList({ cards, disclaimer }) {
  if (!cards || cards.length === 0) {
    return (
      <EmptyState>
        <FileText size={48} style={{ marginBottom: '1rem', opacity: 0.5 }} />
        <p>No specific findings to report.</p>
        <p style={{ fontSize: '0.9rem', marginTop: '0.5rem' }}>
          Your facial features appear well-balanced.
        </p>
      </EmptyState>
    );
  }

  return (
    <ListContainer>
      {disclaimer && (
        <Disclaimer>
          <FileText size={16} />
          {disclaimer}
        </Disclaimer>
      )}
      {cards.map((card, index) => (
        <ConsultCard
          key={index}
          region={card.region}
          subtype={card.subtype}
          finding={card.finding}
          evidence={card.evidence}
          suggestions={card.suggestions}
          confidence={card.confidence}
          surgical={card.surgical}
        />
      ))}
    </ListContainer>
  );
}

export default ConsultList;

